<template>
  <div
    v-if="loadingDetail"
    class="eu-pa_6 eu-align_center"
  >
    <emd-loader :type="'_invert'" />
  </div>
  <div v-else>
    <div class="el-section">
      <div class="emd-container _highlight_header">
        <div class="emd-container__header">
          <h2 class="emd-text _size_section">
            {{ $t('webhook.request.payload') }}
          </h2>
        </div>
        <div class="emd-container__content">
          <div class="emd-panel">
            <div class="emd-panel__section">
              <div class="el-chunk">
                <pre>{{ webhook.request || '-' }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
export default {
  name: 'WebhookRequest',
  components: {
    EmdLoader
  },
  data () {
    return {
      webhook: {},
      loadingDetail: true
    }
  },
  computed: {
    params () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId,
        webhookId: this.$route.params.id
      }
    }
  },
  methods: {
    getWebhook () {
      this.params.query = {
        fields: 'request'
      }
      this.$store.dispatch('GET_WEBHOOK', this.params).then(res => {
        this.loadingDetail = false
        this.webhook = res
      })
    }
  },
  created () {
    this.getWebhook()
  }
}
</script>
